import { OpenAPI, VaultService } from '@api'

export const parseCreatorId = (url: string) => {
  const regex = /\/creators\/(\d+)\//
  const match = url.match(regex)

  return match ? parseInt(match[1], 10) : 0
}

export const removeQueryParams = (url: string) => {
  try {
    const urlWrapper = new URL(url)

    return urlWrapper.origin + urlWrapper.pathname
  } catch (error: any) {
    console.error('Invalid URL:', error.message)

    return null
  }
}

/**
 * Used in canvas based charts, so `img` tag not available.
 */
export const getVaultImageUrl = async (url?: string, creatorId?: number) => {
  if (
    !OpenAPI.TOKEN ||
    !creatorId ||
    !url?.startsWith('https://of-assets.creatorhero.com/')
  ) {
    return url ?? ''
  }

  const chUrl = removeQueryParams(url)

  if (chUrl) {
    try {
      const source = await VaultService.downloadFileV3({
        creatorId: parseCreatorId(url),
        chUrl,
      })

      return URL.createObjectURL(source)
    } catch (error) {
      return ''
    }
  }

  return ''
}
